import { Component, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'afs-footer',
  styleUrl: 'afs-footer.sass',
  shadow: true,
})
export class AfsFooter {

  @Prop() variant : "complex" | "simple" = "complex";

  @Prop() fr : boolean = false;

  @Prop() jackpotUrl: string = 'https://ccbqel594l.execute-api.us-west-2.amazonaws.com/v1/3af28ebf/totaldrawamount';

  @Prop() facebookHref: string;
  @Prop() twitterHref: string;
  @Prop() instagramHref: string;
  @Prop() linkedinHref: string;
  @Prop() youtubeHref: string;

  @Prop() policyHref: string;
  @Prop() winnersHref: string;
  @Prop() rulesHref: string;
  @Prop() supportHref: string;

  @Prop() policyHeading: string = this.fr ? "Politique de confidentialité" : "Privacy Policy";
  @Prop() winnersHeading: string = this.fr ? "Gagnants" : "Winners";
  @Prop() rulesHeading: string = this.fr ? "Règles officielles" : "Official Rules";
  @Prop() supportHeading: string = this.fr ? "Poser une question" : "Ask a Question";

  @Prop() socialMediaHeading: string = this.fr ? "Pour en savoir plus sur la cause" : "Learn more about the cause";
  @Prop() paymentHeading: string = this.fr ? "Modes de paiement acceptés" : "We accept these payment methods";

  @Prop() visa: boolean;
  @Prop() mastercard: boolean;
  @Prop() amex: boolean;
  @Prop() discover: boolean;
  @Prop() maestro: boolean;
  @Prop() debit: boolean;
  @Prop() mastercardDebit: boolean;
  @Prop() visaDebit: boolean;

  @Prop() backgroundColor: string;
  @Prop() color: string;
  @Prop() imageTheme: 'light' | 'dark' = 'light';

  @Prop() copyrightYear : string | number;

  @Prop() gambleWarningLicense : string;

  @State() jackpotVal: any = 0;

  private async jackpotData() {
    try {
      const response = await fetch(this.jackpotUrl);
      const data = await response.json();
      this.jackpotVal = data.total.toLocaleString(this.fr ? 'fr' : 'en');
    } 
    catch (err) {
      console.warn(`Cannot Retrieve Jackpot URL Data : ${err}`);
      this.jackpotVal = 0;
    }
  }

  private getCurrentYear() {
    return new Date().getFullYear();
  }

  componentWillLoad() {
    this.jackpotData();
  }

  render() {
    if (this.variant === "complex") {
      return (
        <Host>
          <footer style={{ backgroundColor: this.backgroundColor, color: this.color }}>
            <div class="footer-container">
              { (this.twitterHref || this.facebookHref || this.instagramHref || this.youtubeHref || this.linkedinHref) && <div class="social">
                <span>{this.socialMediaHeading}</span>
                <ul>
                  { this.twitterHref && <li><afs-asset href={this.twitterHref} src={`social/twitter-${this.imageTheme}.svg`} alt="Twitter icon" fit="contain"></afs-asset></li> }
                  { this.facebookHref && <li><afs-asset href={this.facebookHref} src={`social/facebook-${this.imageTheme}.svg`} alt="Twitter icon" fit="contain"></afs-asset></li> }
                  { this.instagramHref && <li><afs-asset href={this.instagramHref} src={`social/instagram-${this.imageTheme}.svg`} alt="Twitter icon" fit="contain"></afs-asset></li> }
                  { this.youtubeHref && <li><afs-asset href={this.youtubeHref} src={`social/youtube-${this.imageTheme}.svg`} alt="Twitter icon" fit="contain"></afs-asset></li> }
                  { this.linkedinHref && <li><afs-asset href={this.linkedinHref} src={`social/linkedin-${this.imageTheme}.svg`} alt="Twitter icon" fit="contain"></afs-asset></li> }
                </ul>
              </div>}
              <div class="payment">
                <span>{this.paymentHeading}</span>
                <ul>
                  { this.visa && <li><afs-asset src={`payment/visa-${this.imageTheme}.svg`} alt="Visa logo" fit="contain"></afs-asset></li> }
                  { this.visaDebit && <li class="payment-large"><afs-asset src={`payment/visa-debit-${this.imageTheme}.svg`} alt="Visa Debit logo" fit="contain"></afs-asset></li> }
                  { this.mastercard && <li><afs-asset src={`payment/mastercard-${this.imageTheme}.svg`} alt="Mastercard logo" fit="contain"></afs-asset></li> }
                  { this.mastercardDebit && <li class="payment-large"><afs-asset src={`payment/mastercard-debit-${this.imageTheme}.svg`} alt="Mastercard Debit logo" fit="contain"></afs-asset></li> }
                  { this.amex && <li><afs-asset src={`payment/amex-${this.imageTheme}.svg`} alt="American Express logo" fit="contain"></afs-asset></li> }
                  { this.discover && <li><afs-asset src={`payment/discover-${this.imageTheme}.svg`} alt="Discover logo" fit="contain"></afs-asset></li> }
                  { this.maestro && <li><afs-asset src={`payment/maestro-${this.imageTheme}.svg`} alt="Maestro logo" fit="contain"></afs-asset></li> }
                  { this.debit && <li><afs-asset src={`payment/debit-${this.imageTheme}.svg`} alt="Debit logo" fit="contain"></afs-asset></li> }
                </ul>
              </div>
              <div class="links">
                <ul>
                  { this.winnersHref && <li><afs-link href={this.winnersHref}>{this.winnersHeading}</afs-link></li> }
                  { this.policyHref && <li><afs-link href={this.policyHref}>{this.policyHeading}</afs-link></li> }
                  { this.rulesHref && <li><afs-link href={this.rulesHref}>{this.rulesHeading}</afs-link></li> }
                  { this.supportHref && <li><afs-link href={this.supportHref}>{this.supportHeading}</afs-link></li> }
                  <slot name="links"></slot>
                </ul>
              </div>
              <div class="ascend">
                <afs-asset class="ascend-logo" href="https://ascendfs.com" src={`logo/afs-logo-long-${this.imageTheme}.svg`} alt="Ascend Fundraising Solutions Logo" fit="contain" position="right center"></afs-asset>
                { this.fr ?
                  <span class="ascend-raised" style={{letterSpacing: '0.1rem'}}>Plus de {this.jackpotVal} $ <br/>recueillis pour <br/>nos partenaires</span>
                  :
                  <span class="ascend-raised" style={{letterSpacing: '0.2rem'}}>Over ${this.jackpotVal} <br/>Raised For <br/>Our Partners</span>
                }
                { this.fr ?
                  <small class="ascend-copyright">DROITS D'AUTEUR &copy; {this.copyrightYear ?? this.getCurrentYear()} <br/><afs-link href="https://ascendfs.com">Ascend Fundraising Solutions</afs-link><br/> TOUS DROITS RÉSERVÉS</small>
                  :
                  <small class="ascend-copyright">Copyright &copy; {this.copyrightYear ?? this.getCurrentYear()} <br/><afs-link href="https://ascendfs.com">Ascend Fundraising Solutions</afs-link><br/> All Rights Reserved</small>
                }
              </div>
            </div>
          </footer>
          { this.gambleWarningLicense && <afs-gamble-warning-bar license={this.gambleWarningLicense}></afs-gamble-warning-bar> }
        </Host>
      );
    }else {
      return (
        <Host>
          <footer id='custom-footer'>
            <slot name="heading"></slot>
            <div class="flex-container">
                <div id="logo-container" style={{width: "160px"}}>
                    <afs-link href="https://ascendfs.com" target="_blank" rel="noreferrer">
                        <afs-asset src="logo/afs-logo-long-light.svg" alt="Ascend Fundraising Solutions Logo"></afs-asset>
                    </afs-link>
                </div>
                {
                  this.fr ?
                  <span class="ascend-raised">Plus de {this.jackpotVal} $ <br />recueillis pour <br />nos partenaires</span>
                  :
                  <span class="ascend-raised">Over ${this.jackpotVal} <br />Raised For <br />Our Partners</span>
                }
            </div>
            {
              this.fr ?
              <small class="ascend-copyright">
                  DROITS D'AUTEUR &copy; {this.copyrightYear ?? this.getCurrentYear()}
                  <br /> <afs-link href="https://ascendfs.com" target="_blank" rel="noreferrer">Ascend Fundraising Solutions</afs-link> <br />
                  TOUS DROITS RÉSERVÉS
              </small>
              :
              <small class="ascend-copyright">
                  Copyright &copy; {this.copyrightYear ?? this.getCurrentYear()}
                  <br /> <afs-link href="https://ascendfs.com" target="_blank" rel="noreferrer">Ascend Fundraising Solutions</afs-link> <br />
                  All Rights Reserved
              </small>
            }
          </footer>
        </Host>
      );
    }
  }
}
